/** Display balance with exactly two decimal places (UI only). */
export function formatBalanceDisplay(balance: unknown): string {
  const n = typeof balance === 'number' ? balance : Number(balance);
  if (!Number.isFinite(n)) return '0.00';
  return n.toFixed(2);
}
